import { Checkbox } from '@progress/kendo-react-inputs'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { StyledInput } from '~/components/elements/StyledInput'
import { Typography } from '~/components/elements/Typography'
import { useFormField } from '~/hooks/useFormField'
import { type SurveyFilterGroups } from '~/utils'

import { useFilterGroupsToText } from '../../hooks/useFilterGroupsToText'

import { type InputValues } from './utils'

export type ItemProps = {
  filterGroups: SurveyFilterGroups
  index: number
}

export const Item = ({ filterGroups, index }: ItemProps) => {
  const { control } = useFormContext<InputValues>()
  const nameField = useFormField(control, `customerAttributes.${index}.name`)
  const checkedField = useFormField(
    control,
    `customerAttributes.${index}.checked`,
  )
  const checked = checkedField.value

  const filterGroupsToText = useFilterGroupsToText()

  return (
    <>
      <Checkbox {...checkedField} />

      <StyledInput disabled={!checked} width="100%" {...nameField} />

      <Typography color={checked ? 'normal' : 'light'} variant="normal">
        {filterGroupsToText(filterGroups)}
      </Typography>
    </>
  )
}
